export default __webpack_public_path__ + "static/media/help.a6ba800e.svg";